// Display catalog mirrors backend pricing. Backend re-computes totals at checkout.
// Authentic imagery sourced directly from auraglowwellness.com (Aura Glow Wellness CDN).
// Product imagery self-hosted in /public/products (was hotlinked from Shopify, which blocks
// cross-domain loading with a 409). Reliably-hosted brand visuals so nothing breaks in production.
const AG = {
  productClean: "/products/mask-hero.webp?v=2",
  productHero: "/products/mask-hero.webp?v=2",
  angled: "/products/mask-detail.webp",
  detailA: "/products/mask-detail.webp",
  detailB: "/products/mask-detail.webp",
  lifestyle: "/products/mask-lifestyle.webp",
  result1: "https://images.pexels.com/photos/3762879/pexels-photo-3762879.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=900",
  result2: "https://images.pexels.com/photos/3785147/pexels-photo-3785147.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=900",
  box: "/products/mask-box.webp",
};

export const LOGO_URL = "https://auraglowwellness.com/cdn/shop/files/Aura_Glow_Wellness_Logo_18.png?v=1738912442&width=600";

// SEO-friendly product URLs. Route is /product/:sku so any slug renders (old links still work).
export const PRODUCT_SLUGS = { single: "leopard-luxe-led-light-therapy-mask" };
export const productPath = (sku) => `/product/${PRODUCT_SLUGS[sku] || sku}`;

export const IMG = {
  // Mask product imagery, authentic Aura Glow photos
  product: AG.productHero,
  productClean: AG.productClean,
  maskCutout: "/leopard-mask-cutout.webp?v=5",
  lifestyleMask: AG.lifestyle,
  leopardSilk: AG.angled,
  wavelengthGlow: AG.detailA,
  beforeAfter: AG.result1,
  resultB: AG.result2,
  unboxing: AG.box,
  deviceDetail: AG.detailB,
  glowFront: AG.angled,
  apply: AG.lifestyle,
  flexible: AG.angled,
  // Faces & social proof, authentic Aura Glow result imagery
  founder: AG.result1,
  skinA: AG.result1,
  skinB: AG.result2,
  skinC: AG.lifestyle,
  ritual:
    "https://images.pexels.com/photos/7020306/pexels-photo-7020306.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=900",
  dermatologist:
    "https://images.pexels.com/photos/32160039/pexels-photo-32160039.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=900",
  serum:
    "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  cleanser:
    "https://images.unsplash.com/photo-1556228720-195a672e8a03?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  candleHero:
    "https://static.prod-images.emergentagent.com/jobs/6e9e37ac-1f04-43a6-819a-203cd06632b4/images/d3b59cd0bb7e572248735f90936706426051a1a7a2dc7dfed7890ffb897b8db1.png",
  candleMatcha:
    "https://static.prod-images.emergentagent.com/jobs/6e9e37ac-1f04-43a6-819a-203cd06632b4/images/6c3cb2ba15f0ca78a089d8e0bd2af4cd0aecc06a8e046f3c0044b4076749d278.png",
  candleCoffee:
    "https://static.prod-images.emergentagent.com/jobs/6e9e37ac-1f04-43a6-819a-203cd06632b4/images/b35ba90b7aac75ed0df3a2f261b2e42abb36e689244d727b3c16b3790be09d9d.png",
  candleLife:
    "https://static.prod-images.emergentagent.com/jobs/6e9e37ac-1f04-43a6-819a-203cd06632b4/images/74054c06efd4af902f2349a0a6b549a7b55fdcfae0ffa9d80067479ecd45dd88.png",
  stepCleanse:
    "https://static.prod-images.emergentagent.com/jobs/6e9e37ac-1f04-43a6-819a-203cd06632b4/images/f3c37d140e9524edce01d98a32b25275148cab2e0e5de402f9b4f649f3297374.png",
  stepGlow:
    "https://static.prod-images.emergentagent.com/jobs/6e9e37ac-1f04-43a6-819a-203cd06632b4/images/b8d4c611b3f20515a8d65aa24c2926d51b1edeab5c00823d65354e7b7e3e9f56.png",
  matureA:
    "https://images.pexels.com/photos/10222446/pexels-photo-10222446.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720",
  matureB:
    "https://images.unsplash.com/photo-1543430720-fa600c67e423?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  matureC:
    "https://images.pexels.com/photos/10222448/pexels-photo-10222448.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720",
};

export const CATALOG = {
  single: {
    sku: "single",
    name: "Leopard Luxe™ LED Light Therapy Mask",
    subtitle: "The signature single device",
    price: 349,
    compareAt: 490,
    type: "device",
    bestSeller: true,
    image: IMG.product,
    badge: "Best Seller",
  },
  duo: {
    sku: "duo",
    name: "The Glow Duo",
    subtitle: "Two masks, one for you, one to gift",
    price: 458,
    compareAt: 692,
    type: "bundle",
    image: IMG.unboxing,
    badge: "Save $234",
    hidden: true,
  },
  ritual: {
    sku: "ritual",
    name: "The Complete Glow Ritual",
    subtitle: "Mask + Renewal Serum + Silk Travel Case",
    price: 299,
    compareAt: 434,
    type: "bundle",
    image: IMG.deviceDetail,
    badge: "Most Loved",
    hidden: true,
  },
  serum: {
    sku: "serum",
    name: "Aura Renewal Serum",
    subtitle: "Hyaluronic + peptide glow primer, 30ml",
    price: 49,
    compareAt: 69,
    type: "addon",
    image: IMG.serum,
    soldOut: true,
  },
  cleanser: {
    sku: "cleanser",
    name: "Gentle Glow Cleanser",
    subtitle: "Prep your skin before every session, 150ml",
    price: 39,
    compareAt: 52,
    type: "addon",
    image: IMG.cleanser,
    soldOut: true,
  },
  protection: {
    sku: "protection",
    name: "VIP Order Protection",
    subtitle: "Shipping protection, priority processing & 2-year warranty",
    price: 19,
    compareAt: 19,
    type: "addon",
    image: IMG.unboxing,
  },
};

export const CANDLES = {
  candle_coffee: { sku: "candle_coffee", name: "Cold Brew Coffee", subtitle: "Bold, energising & oh-so-cool", price: 50, compareAt: 65, type: "candle", emoji: "☕", image: IMG.candleCoffee },
  candle_chai: { sku: "candle_chai", name: "Chai Latte", subtitle: "Spiced warmth that feels like a hug", price: 50, compareAt: 65, type: "candle", emoji: "🌰", image: IMG.candleCoffee },
  candle_matcha: { sku: "candle_matcha", name: "Matcha Latte", subtitle: "Earthy, calming & beautifully balanced", price: 50, compareAt: 65, type: "candle", emoji: "🍵", image: IMG.candleMatcha },
  candle_strawberry: { sku: "candle_strawberry", name: "Strawberry Matcha", subtitle: "Sweet, creamy & a little bit dreamy", price: 50, compareAt: 65, type: "candle", emoji: "🍓", image: IMG.candleMatcha },
  candle_lavender: { sku: "candle_lavender", name: "Lavender Latte", subtitle: "Floral, calming & perfect for winding down", price: 50, compareAt: 65, type: "candle", emoji: "💜", image: IMG.candleHero },
  candle_lemon: { sku: "candle_lemon", name: "Iced Lemon Latte", subtitle: "Zesty, refreshing & pure sunshine", price: 50, compareAt: 65, type: "candle", emoji: "🍋", image: IMG.candleLife },
};

// Candle scents available on the category page (in display order)
export const CANDLE_NAMES = ["candle_coffee", "candle_chai", "candle_matcha", "candle_strawberry", "candle_lavender", "candle_lemon"];

Object.assign(CATALOG, CANDLES);

// Maps backend product SKUs to the semantic IMG keys used across the storefront.
const SKU_IMG_KEY = {
  single: "product", duo: "unboxing", ritual: "deviceDetail",
  serum: "serum", cleanser: "cleanser",
  candle_coffee: "candleCoffee", candle_chai: "candleCoffee",
  candle_matcha: "candleMatcha", candle_strawberry: "candleMatcha",
  candle_lavender: "candleHero", candle_lemon: "candleLife",
};

// Applies admin-uploaded image overrides (keyed by SKU) onto the live catalog at runtime.
export function applyImageOverrides(overrides, backendUrl = "") {
  Object.entries(overrides || {}).forEach(([sku, url]) => {
    if (!url) return;
    const full = url.startsWith("http") ? url : `${backendUrl}${url}`;
    if (CATALOG[sku]) CATALOG[sku].image = full;
    const key = SKU_IMG_KEY[sku];
    if (key) IMG[key] = full;
  });
}

export const fmt = (n) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: n % 1 ? 2 : 0 }).format(n);

// Auto-applied storewide promo — GLOW20 unlocks the Winter Sale price (already the listed price)
export const PROMO = { code: "GLOW20", endsLabel: "Ends July 31" };
export const applyPromo = (subtotal) => ({ discount: 0, total: subtotal });
